import React from "react";
import { FormWrapper } from "../../../../../../../shared/components/FormWrapper";

export const AddressComplementFormWrapper = ({ children, data }) => {
  return <FormWrapper defaultValues={data}>{children}</FormWrapper>;
};
